<template>
    <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <v-col>
            <h3>{{ gameTitle }}</h3>
            <h5>{{ gameDate }}</h5>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="loginForm" >
                <v-row
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <v-select
                    v-model="gameState"
                    :items="stateOptions"
                    item-text="title"
                    item-value="value"
                    label="State"
                  ></v-select>
                </v-row>
            </v-form>

          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-progress-circular
            v-if="updating"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            :disabled="updating"
            text
            @click="closeDialog(false)"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            :disabled="updating"
            text
            @click="closeDialog(true)"
          >
            Save
          </v-btn>
          <v-btn
            color="blue darken-1"
            :disabled="updating"
            text
            @click="deleteState = true"
          >
            Delete
          </v-btn>
        </v-card-actions>
        <v-alert
          v-if="deleteState"
          border="top"
          color="red lighten-2"
          dark
          transition="scale-transition"
          >Are you sure you wish to delete game {{gameTitle}}
          <v-row justify="center" class="my-6">
            <v-btn
              color="blue darken-1"
              class="mr-12"
              @click="deleteState = false"
            >
              NO
            </v-btn>
            <v-btn
              color="blue darken-1"
              class="ml-12"
              @click="deleteGame()"
            >
              YES
            </v-btn>
          </v-row>
        </v-alert>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from "axios";
export default {
    name: "EditGame",
    data() {
        return {
            dialog: false,
            deleteState: false,
            gameApi: process.env.VUE_APP_API_GAMES,
            stateOptions: [
              {title: "Pending", value: 0}, 
              {title: "Ready", value: 1}, 
              {title: "Played", value: 2}, 
              {title: "Approved", value: 3}
              ],
            gameState: 0,
            updating: false
        };
    },
    props: {
        showDialog: {
            type: Boolean,
            default() {
                return false;
            },
        },
        game: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    watch: {
        showDialog() {
            this.dialog = this.showDialog;
        },
        game: {
          deep: true,
          handler(){
            this.gameState = this.game.state
          }
        }
    },
    methods: {
        closeDialog(save) {
          if(save){
            this.game.state = this.gameState
            this.updating = true
            axios.put(`${this.gameApi}/${this.game.id}/`, {
                data: {
                    state: this.gameState,
                }, 
                }, {
                  headers: {
                    "Authorization": this.token,
                    "Content-Type": "application/json"
                    }
            }).then((res) => {
              this.updating = false
              this.$store.commit("updateGame", res.data);
              this.$emit("closeDialog")
              })
              .catch((e) => {
                console.log(e)
                this.updating = false
              })
          }
          else
            this.$emit("closeDialog")
        },
        deleteGame(){
          this.updating = true
          this.deleteState = false
          axios.delete(`${this.gameApi}/${this.game.id}/`, {
                  headers: {
                    "Authorization": this.token
                    }
            }).then(() => {
              this.updating = false
              this.$store.commit("deleteGame", this.game.id);
              this.$emit("closeDialog")
              })
              .catch((e) => {
                console.log(e)
                this.updating = false
              })
        }
    },
    computed: {
      ...mapGetters(['token']),
      gameTitle(){
        return this.game?.name ? `${this.game.name} - id: ${this.game.id}` : ""
      },
      gameDate(){
        return this.game ? new Date(this.game.date).toLocaleString() : ""
      }
    }
};
</script>

<style lang="scss" scoped>
</style>